import useAuthentication from 'shared/auth/hooks/use-authentication/use-authentication'
import { useEffect } from 'react'
import { Home } from 'Pages/Home/Home'
import { TaskPage } from 'Pages/Task/Task'
import { UserDetailsProvider } from './contexts/UserDetailsContext'
import { PreviewPage } from 'Pages/Preview/Preview'
import ReactGA from 'react-ga4'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { appConfig } from 'Config/app-config'
import Spin from 'antd/lib/spin'
import { Loader } from 'Components/common/Loader/Loader'
import { ExamDetailPage } from 'Pages/ExamDetail/ExamDetail'
import { ExamTaskPage } from 'Pages/ExamTask/ExamTask'
import { ResultPage } from 'Pages/Result/Result'
import { ExamPreviewPage } from 'Pages/ExamPreview/ExamPreview'
import { TaskFeedbackPreview } from 'Pages/Preview/TaskFeedbackPreview.tsx'
import SavedForLaterTasks from 'Components/common/SavedForLater/SavedForLater.tsx'
import { OnHoldTaskPreview } from 'Pages/Preview/OnHoldTaskPreview'
import { registerTasks } from 'Tasks/TaskRegistration'
import { TimesheetForm } from 'Pages/TimesheetForm/TimesheetForm'

ReactGA.initialize(appConfig.gamId ?? '')

const RoutesComp = () => {
    const location = useLocation()

    useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search })
    }, [location])

    const {
        trigger: triggerAuthentication,
        customMessage,
        error,
        isAuthenticated,
        isLoading,
        userId,
    } = useAuthentication()

    useEffect(() => {
        triggerAuthentication(undefined)
    }, [triggerAuthentication])

    useEffect(() => {
        registerTasks()
    }, [])

    if (isLoading) {
        return <Spin indicator={<Loader title={'Loading...'} />} />
    }

    if (customMessage) {
        return <>{customMessage}</>
    }

    if (error) {
        return <div>{(error as { message: string }).message}</div>
    }

    if (!isAuthenticated) {
        return <Spin indicator={<Loader title={'Loading...'} />} />
    }

    return (
        <UserDetailsProvider value={{ userID: userId }}>
            <Routes>
                <Route element={<Home />} path="/" />
                <Route element={<TaskPage />} path="/task-queue/:stepId" />
                <Route element={<PreviewPage />} path="/preview/:jobId" />
                <Route element={<ExamDetailPage />} path="/exam/:examId" />
                <Route element={<ExamTaskPage />} path="/exam/:examId/attempt/:attemptId" />
                <Route element={<ResultPage />} path="/exam/:examId/attempt/:attemptId/result" />
                <Route element={<TaskFeedbackPreview />} path="/preview-task/:taskId" />
                <Route
                    element={<ExamPreviewPage />}
                    path="/exam-versions/:examVersionId/questionsets/:questionsetVersionId/questions/:questionVersionId/preview"
                />
                <Route element={<SavedForLaterTasks />} path="/saved/:stepId" />
                <Route element={<OnHoldTaskPreview />} path="/preview-on-hold/:taskId" />
                <Route element={<TimesheetForm />} path="/timesheet/:projectId" />
                <Route element={<Navigate to="/" />} path="*" />
            </Routes>
        </UserDetailsProvider>
    )
}

export default RoutesComp
